const AlignLeft = () => {
  return (
    <svg
      width="93"
      height="93"
      viewBox="0 0 93 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="93" height="93" rx="46.5" fill="none" />
      <g clipPath="url(#clip0_127_3275)">
        <path
          d="M46.4922 24.479C38.3943 24.479 30.2947 24.479 22.1934 24.479C21.7886 24.4955 21.3833 24.4591 20.988 24.3705C19.6552 24.0124 18.8682 22.7725 19.0284 21.3588C19.1125 20.7256 19.418 20.1426 19.8908 19.713C20.3635 19.2835 20.973 19.035 21.6113 19.0117C21.8249 19.0014 22.0401 19.0031 22.2554 19.0031C38.411 19.0031 54.5671 19.0031 70.7239 19.0031C71.216 18.9853 71.708 19.0434 72.1824 19.1753C73.4377 19.5834 74.142 20.837 73.9543 22.1854C73.8571 22.7951 73.5549 23.3535 73.0975 23.7684C72.6401 24.1832 72.0549 24.4296 71.4385 24.467C71.1613 24.4842 70.8806 24.479 70.6016 24.479H46.4922Z"
          fill="black"
        />
        <path
          d="M46.5589 52.0106C54.7004 52.0106 62.8425 52.0106 70.9852 52.0106C72.8794 52.0106 74.0951 53.2384 73.9677 55.0086C73.9142 55.6346 73.6443 56.2224 73.2043 56.6709C72.7643 57.1193 72.1817 57.4005 71.5569 57.4658C71.2779 57.4917 70.999 57.4882 70.7183 57.4882C54.5627 57.4882 38.4065 57.4882 22.2498 57.4882C21.8214 57.5072 21.3925 57.4701 20.9738 57.378C19.6427 57.0181 18.8592 55.7766 19.021 54.3628C19.0991 53.7282 19.4031 53.1429 19.8775 52.7141C20.3518 52.2853 20.9647 52.0417 21.604 52.0278C23.9252 51.9951 26.2447 52.0123 28.566 52.0123L46.5589 52.0106Z"
          fill="black"
        />
        <path
          d="M38.2444 40.986C32.896 40.986 27.5469 40.986 22.1973 40.986C21.7926 41.0029 21.3874 40.967 20.9919 40.8792C19.6591 40.5228 18.8722 39.2847 19.0272 37.8709C19.1105 37.2369 19.4156 36.6529 19.8884 36.2224C20.3612 35.7918 20.9711 35.5425 21.6101 35.5187C21.7823 35.5187 21.9545 35.5187 22.1267 35.5187C32.8684 35.5187 43.6101 35.5187 54.3518 35.5187C54.7376 35.5032 55.1238 35.5385 55.5004 35.6237C56.8418 35.9802 57.6443 37.2648 57.448 38.694C57.3519 39.3386 57.0246 39.9263 56.5272 40.3474C56.0297 40.7685 55.3961 40.9942 54.7444 40.9825C50.319 41.0015 45.8935 40.9911 41.468 40.9911L38.2444 40.986Z"
          fill="black"
        />
        <path
          d="M38.2388 73.9931C32.8903 73.9931 27.5413 73.9931 22.1917 73.9931C21.7869 74.0096 21.3817 73.9731 20.9863 73.8846C19.6535 73.5247 18.8683 72.2866 19.0284 70.8729C19.1126 70.2397 19.418 69.6567 19.8908 69.2271C20.3635 68.7975 20.973 68.5491 21.6114 68.5258C21.8042 68.5155 21.9988 68.5172 22.1917 68.5172C32.8909 68.5172 43.5896 68.5172 54.2876 68.5172C54.6923 68.5005 55.0974 68.5358 55.493 68.6222C56.8241 68.9821 57.6111 70.2254 57.4509 71.6357C57.3743 72.2714 57.0709 72.8581 56.5964 73.2881C56.1219 73.718 55.5081 73.9622 54.8679 73.9759C52.1627 74.0086 49.4558 73.9914 46.7488 73.9914L38.2388 73.9931Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_127_3275">
          <rect
            width="54.9793"
            height="55"
            fill="white"
            transform="translate(19 19)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlignLeft;
